/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * VAT Tax Switcher (Anowave) – Warehouse bridges
 *
 * - Forward Warehouse cart/variant events so the app re-applies prices
 * - On mobile, move the toggle under the search bar (centred)
 * - On desktop, keep it in .header__icons
 */
(function () {
  function notifyVatSwitcher() {
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('variant:change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('shopify:section:render', { bubbles: true }));
    }, 150);
  }

  function isMobileHeader() {
    return window.matchMedia && window.matchMedia('(max-width: 999px)').matches;
  }

  function syncVatLabelState(switcher) {
    if (!switcher) return;
    var checkbox = switcher.querySelector('.toggle-checkbox');
    if (!checkbox) return;
    switcher.classList.toggle('is-incl', !!checkbox.checked);
    switcher.classList.toggle('is-excl', !checkbox.checked);
  }

  function enhanceVatToggle(switcher) {
    if (!switcher || switcher.dataset.vatEnhanced === 'true') return;
    switcher.dataset.vatEnhanced = 'true';

    var checkbox = switcher.querySelector('.toggle-checkbox');
    if (checkbox) {
      var sync = function () {
        syncVatLabelState(switcher);
      };
      checkbox.addEventListener('change', sync);
      checkbox.addEventListener('click', function () {
        setTimeout(sync, 0);
      });
    }

    var trial = switcher.querySelector('.toggle-trial');
    if (trial) trial.style.display = 'none';

    syncVatLabelState(switcher);
  }

  function findHeaderToggle() {
    return (
      document.querySelector('.header__vat-bar .tax-switcher') ||
      document.querySelector('.header__icons .tax-switcher') ||
      document.querySelector('.header__action-list > .tax-switcher')
    );
  }

  function prepareMobileVatToggle() {
    var bar = document.querySelector('.header__vat-bar');
    var icons = document.querySelector('.header__icons');
    var toggle = findHeaderToggle();

    // Drop any drawer duplicates the app may inject
    document.querySelectorAll('.mobile-menu .tax-switcher').forEach(function (el) {
      el.remove();
    });

    if (!toggle) return;

    if (isMobileHeader()) {
      if (bar && toggle.parentElement !== bar) {
        bar.appendChild(toggle);
      }
      // Restore full labels if we previously shortened them
      toggle.querySelectorAll('.toggle-label').forEach(function (label) {
        if (label.dataset.fullLabel) label.textContent = label.dataset.fullLabel;
      });
      enhanceVatToggle(toggle);
    } else if (icons && toggle.parentElement !== icons) {
      icons.appendChild(toggle);
      enhanceVatToggle(toggle);
    }
  }

  document.addEventListener('variant:changed', notifyVatSwitcher);
  document.addEventListener('product:added', notifyVatSwitcher);
  document.addEventListener('cart:refresh', notifyVatSwitcher);
  document.documentElement.addEventListener('cart:refresh', notifyVatSwitcher);

  function boot() {
    setTimeout(prepareMobileVatToggle, 300);
    setTimeout(prepareMobileVatToggle, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', function () {
    setTimeout(prepareMobileVatToggle, 100);
  });
})();
